import './wdyr';
import React from 'react';
import { render } from 'react-dom';
import Listing from './Listing';
import { ProductsCards as ProductsCardsImport } from './modules';
import { getAlgoliaAppInfo } from './utils';

export { default as Listing } from './Listing';

export const ProductsCards = ProductsCardsImport;

export function removeReactListing(node) {
    return import('react-dom').then(ReactDOM => {
        ReactDOM.unmountComponentAtNode(node);
    });
}

export function initReactListing(node) {
    const algolia = getAlgoliaAppInfo();
    const state = { data: { algolia } };
    render(<Listing state={state} />, node);
}

export function initProductsCards(node, props) {
    render(<ProductsCards {...props} />, node);
}

export default {
    initReactListing,
    initProductsCards,
    removeReactListing,
    Listing,
    ProductsCards,
};
